export default "__VITE_ASSET__BzgGWk2v__"